/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
import moment from "moment";
import { IntlShape } from "react-intl";
import { getFreightModeIcon } from "helpers/freightModeHelper";

const getLatestQuotationColumns = (intl: IntlShape) => {
  const columns = [
    {
      Header: intl.formatMessage({ id: "general.shipment", defaultMessage: "Shipment" }),
      accessor: (row: any) => [row?.reference, row?.general.created],

      Cell: ({ value }: any) => (
          <>
            <div className="mr-2 font-b4">{`${value[0]}`}</div>
            <div className="mr-2 mt-1">{`${moment(value[1]).format("D MMM YYYY - HH:mm a")}`}</div>
          </>
        ),
      disableDrag: true,
    },
    {
      Header: intl.formatMessage({ id: "general.freightMode", defaultMessage: "Freight mode" }),
      accessor: (row: any) => [row?.service.freight_mode_label],

      Cell: ({ value }: any) => {
        const isDark = true;
        const type = "";
        const Icon = getFreightModeIcon(value, type, isDark);
        return <div className="mr-2">{Icon && <Icon />}</div>;
      },
      disableDrag: true,
    },
    {
      Header: intl.formatMessage({ id: "new-request.packing-list.commodity", defaultMessage: "Commodity" }),
      accessor: (row: any) => [row?.good.total_weight_in_kg, row?.good.total_cbm, row?.good?.items[0]?.units],

      Cell: ({ value }: any) => {
        if (!value) return;
        return (
          <>
            <div className="mr-2">{`${value[0]} Kg Gross Weight`}</div>
            <div className="mr-2 mt-1">{`${value[1]} Kg Gross Weight`}</div>
            <div className="mr-2 mt-1">{`${value[2]} Box`}</div>
          </>
        );
      },
      disableDrag: true,
    },
    {
      Header: intl.formatMessage({ id: "new-request.packing-list.customCommodityValue", defaultMessage: "Value" }),
      accessor: (row: any) => [row?.financial.total_quoted_amount_currency, row?.financial.total_quoted_amount_usd],

      Cell: ({ value }: any) => (
        <div className="d-flex align-item-center">
          <div className="mr-2">{`${value[0]}`}</div>
          <div className="mr-2">{`${value[1]}`}</div>
        </div>
      ),
      disableDrag: true,
    },
  ];

  return columns;
};

export default getLatestQuotationColumns;
